﻿$(document).ready(function () {
    var parentWindow = window.parent.window;
    var model = {};
    var localStorageName = "iframeSourceHref";

    if (window !== parentWindow) {
        model = {
            resizeFrame: true,
            heightSetting: document.documentElement.offsetHeight,
            sourceHref: window.location.href
        };
        
        var hrefFormLocalStorage = localStorage.getItem(localStorageName);

        if (hrefFormLocalStorage && model.sourceHref !== hrefFormLocalStorage) {
            model.oldSourceHref = hrefFormLocalStorage;
            localStorage.removeItem(localStorageName);
        }
        
        parentWindow.postMessage(JSON.stringify(model), "*");

        function updateParentWindow() {
            model.heightSetting = document.documentElement.offsetHeight;
            parentWindow.postMessage(JSON.stringify(model), "*");
        }

        window.updateIframeHeight = updateParentWindow;

        var timeoutId;
        var checkSize = function () {
            if (model.heightSetting === document.documentElement.offsetHeight) {
                timeoutId = setTimeout(function () {
                    checkSize();
                },
                    500);
            } else {
                clearTimeout(timeoutId);
                updateParentWindow();
            }
        };

        $(document).find('input, select').change(function () {
            updateParentWindow();
        });

        $(document).find('form').submit(function () {
            checkSize();
        });

        $(document).find('.EPiServerForms').on("formsSubmitted", function () {
            localStorage.setItem(localStorageName, model.sourceHref);
            checkSize();
        });
    }
});